import {pick} from 'lodash'
import React from 'react'
import Modal from 'react-modal'
import TabBar from './tab-bar'
import Text from 'react-text'
import {Context} from '../../context'
import CatalogueStep from './catalogue-step'
import MyLessonsStep from './my-lessons-step'
import {faTimesCircle} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"

import './index.styl'

function Buttons ({label, onClick, enabled}) {
  return (
    <div className="buttons" style={{display: "flex"}}>
      <div style={{flexGrow: 1}} />
      <button disabled={!enabled} className={label} onClick={onClick}>
        <Text id={label} />
      </button>
    </div>
  )
}

export default class AddLesson extends React.Component {

  static contextType = Context

  constructor (props) {
    super(props)
    const setState = this.setState.bind(this)
    this.state = {
      isOpen: true,
      setState
    }
  }

  render () {

    const context = this.context
    const template = context.query.template
    const {newPlan, activeTab = 'catalogue', navigate} = context
    const {setState, isOpen} = this.state
    const close = () => setState({isOpen: false})
    const navigateOut = () => {
      context.navigate({}, context.match.path.replace(/\/:section.*$/,''), {query: {template}})
    }

    return (
      <Modal
        isOpen={isOpen}
        onAfterClose={navigateOut}
        onRequestClose={close}
        contentLabel=""
        className="add-lesson-wrapper"
        appElement={document.querySelector('#root')}
        closeTimeoutMS={800}
        >
          <div className="add-lesson">
            <div className="title">
              <div className="label">
                <Text id="add-lessons" />
                {newPlan.title != "" && `: ${newPlan.title}`}
              </div>
              <div className="close" onClick={() => close()}>
                <FontAwesomeIcon icon={faTimesCircle} />
              </div>
            </div>
            <TabBar {...{activeTab, navigate, template}} />
            <div className="tab-content">
              {activeTab == 'catalogue' && (<CatalogueStep {...pick(this.state, ['setState'])} />)}
              {/*{activeTab == 'my-lessons' && (<MyLessonsStep {...pick(this.state, ['setState'])} />)}*/}
              <Buttons {...{label: 'accept', onClick: close, enabled: true}} />
            </div>
          </div>
        </Modal>
    )
  }
}
